import { useDispatch, useSelector } from "react-redux"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { getPageData } from "../../../../../redux/actions/VideoAction.jsx"
import TableView, {
  formatterRowComponent,
  initialFilterTable
} from "../../../../../component/atoms/Tabel/index.jsx"
import { Card, CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { sortCaret } from "../../../../../_metronic/_helpers/index.js"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { DetailSvgIcon, EditSvgIcon } from "../../../../../component/atoms/Icons/SVG/index.jsx"
import { EmptyCard, Search, TableSkeleton } from "../../../../../component/index.jsx"
import { Popup } from "../../../../../component/atoms/Popup/index.jsx"
import { loadUserLogin } from "../../../../service/userManagementAction.js"
import { linkWithCtrl } from "../../../../helpers/Utils.js"
import { useTranslation } from "react-i18next"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"

export const ListVideo = ({
  history,
  match: {
    params: { reqName }
  }
}) => {
  const privileges = loadUserLogin().privilege
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { General, Video } = useSelector((state) => state)
  const formRef = useRef()
  const [search, setSearch] = useState({
    string_filter: ""
  })
  const [isFilter, setIsFilter] = useState(false)
  const [showPopupError, setShowPopupError] = useState(false)

  useEffect(() => {
    subHeader.setButton(btnCreate)
    subHeader.setTitle(t("sub_header_manage_video_tutorial"))
    return () => {
      subHeader.setButton(null)
    }
  }, [])

  useEffect(() => {
    dispatch(getPageData({ pageReq: initialFilterTable }))
  }, [dispatch, reqName])

  const changePage = useCallback(
    (param) => {
      let newParam = {
        ...search,
        ...param
      }
      dispatch(getPageData({ pageReq: newParam }))
    },
    [dispatch, search]
  )

  const seacrhFunc = (values) => {
    let param = {
      ...initialFilterTable,
      string_filter: values.string_filter
    }
    setSearch({
      string_filter: values.string_filter
    })
    setIsFilter(true)
    dispatch(getPageData({ pageReq: param }))
  }

  const handleResetSearch = () => {
    setSearch({
      string_filter: ""
    })
    setIsFilter(false)
    let param = {
      ...initialFilterTable,
      string_filter: ""
    }
    dispatch(getPageData({ pageReq: param }))
  }

  useEffect(() => {
    if (isFilter) {
      if (Video.pageData.length === 0) {
        setShowPopupError(true)
      }
    }
  }, [Video.pageData])

  const uiTitle = (e) => {
    return (
      <>
        <span className="text-dark font-weight-bolder mb-1 font-size-lg elipsis-1">{e.title}</span>
      </>
    )
  }

  const uiAction = (e) => {
    return (
      <>
        {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_VIDEO) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-detail-tooltip">Detail</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-1"
              onClick={() => history.push(RoutesConstants.VIDEO.DETAIL(e.id))}>
              <DetailSvgIcon />
            </div>
          </OverlayTrigger>
        )}
        {privileges.indexOf(PRIVILEGE_ENUM.UPDATE_VIDEO) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-1"
              onClick={() => history.push(RoutesConstants.VIDEO.EDIT(e.id))}>
              <EditSvgIcon />
            </div>
          </OverlayTrigger>
        )}
      </>
    )
  }

  const columns = [
    {
      dataField: "title",
      text: t("label_video_title").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiTitle
      },
      sortCaret: sortCaret,
      sort: true,
      headerStyle: () => {
        return { width: "60%" }
      },
      onSort: (field, order) => {
        let param = {
          ...initialFilterTable,
          sort: field + "," + order
        }
        dispatch(getPageData({ pageReq: param }))
      }
    },
    {
      dataField: "category",
      text: t("label_video_category").toUpperCase(),
      formatter: formatterRowComponent,
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = {
          ...initialFilterTable,
          sort: field + "," + order
        }
        dispatch(getPageData({ pageReq: param }))
      }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      }
    }
  ]

  const btnCreate = (
    <>
      {privileges.indexOf(PRIVILEGE_ENUM.INSERT_VIDEO) > -1 && (
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            history.push(RoutesConstants.VIDEO.CREATE())
          }}>
          {t("label_add_video")}
        </button>
      )}
    </>
  )

  return (
    <div>
      <Popup
        type={"empty"}
        body={<span>{t("label_empty_data")}</span>}
        centered={true}
        persistent={true}
        show={showPopupError}
        onClick={() => {
          setShowPopupError(false)
        }}
      />
      <div className="filter-container">
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-10">
          <Search
            // seacrh
            placeholder={t("placeholder_input_video_title")}
            onSubmitForm={seacrhFunc}
            initialValues={search}
            name={"string_filter"}
            innerRef={formRef}
            trigerReset={handleResetSearch}
          />
        </div>
      </div>
      <Card>
        <CardBody>
          {General.loading ? (
            <TableSkeleton column={3} row={10} />
          ) : Video.pageData?.length === 0 ? (
            <EmptyCard body={t("messages_response_empty_state")} />
          ) : (
            ""
          )}
          <br />
          <TableView
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            dataTable={Video.pageData}
            currentPage={Video.page.currentPage}
            currentElement={Video.page.currentElement}
            totalCount={Video.page.totalCount}
            loadingGetData={General.loading}
            rowClasses={() => {
              return "cursor-pointer"
            }}
            rowEvents={{
              onClick: (e, row) => {
                if (e.target.cellIndex < 2) {
                  const url = RoutesConstants.VIDEO.DETAIL(row.id)
                  if (e.ctrlKey) {
                    linkWithCtrl(url)
                  } else {
                    history.push(url)
                  }
                }
              }
            }}
          />
        </CardBody>
      </Card>
    </div>
  )
}